module.exports = __webpack_public_path__ + "media/images/emblems/Champtauroz-coat_of_arms-70158c8aed62efe7956da82d2427ec15.svg";